'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;
exports.default = reducer;

var _reduxActions = require('redux-actions');

var INIT = 'ms/request/init';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case INIT:
      return action.payload;

    default:
      return state;
  }
}

var init = exports.init = (0, _reduxActions.createAction)(INIT);


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/server.js
// module id = 2178
// module chunks = 0